import React from 'react';
import './GovMapData.css';

const GovMapData = ({ coordinates, propertyInfo }) => {
  // Use data from propertyInfo.advancedLayers (already fetched by GovMapService)
  const data = propertyInfo?.advancedLayers || null;
  
  // Get the main gush/helka from propertyInfo
  const mainGush = propertyInfo?.gush;
  const mainHelka = propertyInfo?.helka;

  // Debug logging
  console.log('📊 GovMapData component received:', {
    hasData: !!data,
    dataKeys: data ? Object.keys(data) : [],
    ownership: data?.ownership?.length || 0,
    socioEconomic: !!data?.socioEconomic,
    buildingStats: !!data?.buildingStats,
    buildingStatsData: data?.buildingStats
  });

  // Don't render if no data available from GovMapService
  if (!data) {
    return null;
  }

  // Filter ownership to only show the main parcel
  const filteredOwnership = data.ownership?.filter(parcel => 
    String(parcel['גוש']) === String(mainGush) && 
    String(parcel['חלקה']) === String(mainHelka)
  ) || [];

  const hasData = filteredOwnership.length > 0 || 
                  data.socioEconomic || data.buildingStats;

  if (!hasData) {
    return null;
  }

  const ownershipData = filteredOwnership[0] || null;

  return (
    <>
        {/* Ownership Data */}
        {ownershipData && (
          <>
            {ownershipData['סוג בעלות'] && (
              <div className="data-item">
                <span className="data-label">סוג בעלות:</span>
                <span className={`data-value ownership-badge ${ownershipData['סוג בעלות'] === 'פרטית' ? 'private' : 'public'}`}>
                  {ownershipData['סוג בעלות']}
                </span>
                <p className="data-description">סוג הבעלות על החלקה - פרטית או ציבורית (מינהל מקרקעי ישראל).</p>
              </div>
            )}
            {ownershipData['שטח רשום (מ"ר)'] && (
              <div className="data-item">
                <span className="data-label">שטח רשום:</span>
                <span className="data-value">{ownershipData['שטח רשום (מ"ר)']} מ״ר</span>
                <p className="data-description">השטח הרשום של החלקה במרשם המקרקעין.</p>
              </div>
            )}
          </>
        )}

        {/* Socio-Economic Data */}
        {data.socioEconomic && (
          <>
            {data.socioEconomic['אשכול מדד 2021'] && (
              <div className="data-item">
                <span className="data-label">אשכול סוציו-אקונומי:</span>
                <span className="data-value socio-cluster">
                  {data.socioEconomic['אשכול מדד 2021']}/10
                </span>
                <p className="data-description">דירוג האזור הסטטיסטי לפי מדד חברתי-כלכלי (10 הגבוה ביותר).</p>
              </div>
            )}
            {data.socioEconomic['תפקוד עיקרי לאזור סטטיסטי'] && (
              <div className="data-item">
                <span className="data-label">תפקוד עיקרי:</span>
                <span className="data-value">{data.socioEconomic['תפקוד עיקרי לאזור סטטיסטי']}</span>
                <p className="data-description">הייעוד העיקרי של האזור הסטטיסטי (מגורים, תעשייה, מסחר וכו׳).</p>
              </div>
            )}
          </>
        )}

        {/* Building Stats Data */}
        {data.buildingStats && (
          <>
            {data.buildingStats['גובה המבנה במטרים'] && (
              <div className="data-item">
                <span className="data-label">גובה מבנה:</span>
                <span className="data-value">{data.buildingStats['גובה המבנה במטרים']} מ׳</span>
                <p className="data-description">גובה המבנה הרשום לפי מרכב הבניינים.</p>
              </div>
            )}
            {data.buildingAreaOnParcel?.isPartial ? (
              <>
                <div className="data-item">
                  <span className="data-label">שטח מבנה על החלקה:</span>
                  <span className="data-value">{data.buildingAreaOnParcel.buildingAreaOnParcel} מ״ר</span>
                  <p className="data-description">
                    שטח טביעת הרגל של המבנה בתחום החלקה ({data.buildingAreaOnParcel.coveragePercent}% מתוך {data.buildingAreaOnParcel.totalBuildingArea} מ״ר סה״כ). המבנה חורג מגבולות החלקה.
                  </p>
                </div>
              </>
            ) : data.buildingStats['שטח במטרים רבועים'] && (
              <div className="data-item">
                <span className="data-label">שטח מבנה:</span>
                <span className="data-value">{data.buildingStats['שטח במטרים רבועים']} מ״ר</span>
                <p className="data-description">שטח המבנה הרשום במרכב הבניינים.</p>
              </div>
            )}
          </>
        )}
    </>
  );
};

export default GovMapData;
